import { render, staticRenderFns } from "./custom-product-title.vue?vue&type=template&id=3d1e4beb"
import script from "./custom-product-title.vue?vue&type=script&lang=js"
export * from "./custom-product-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports